/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../banking/common';
import '../../../common/currency_codes';
import '../../../connect/v2/common/money';
import '../../../banking/account_model';
import '../../../common/time';
import '../../../ledger/ledger';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bankingaccounts": {
        "nested": {
          "external": {
            "nested": {
              "model": {
                "nested": {
                  "BankAccount": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "depositAccount": {
                        "type": ".squareup.bankingaccounts.external.model.DepositAccount",
                        "id": 1
                      },
                      "paymentAccount": {
                        "type": ".squareup.bankingaccounts.external.model.PaymentAccount",
                        "id": 2
                      }
                    },
                    "nested": {
                      "AccountProductType": {
                        "values": {
                          "UNKNOWN_PRODUCT_DO_NOT_USE": 0,
                          "SQUARE_US_SAVINGS": 1,
                          "SQUARE_US_CHECKING": 2,
                          "SQUARE_CA_FOLDER": 3,
                          "CA_SQUARE_CARD": 4,
                          "GB_SQUARE_CARD": 5,
                          "PAYMENT_ACCOUNT": 6
                        }
                      },
                      "bank_account": {
                        "oneof": ["depositAccount", "paymentAccount"]
                      }
                    }
                  },
                  "DepositAccount": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "state": {
                        "type": ".squareup.bankingaccounts.external.model.DepositAccount.DepositAccountState",
                        "id": 2,
                        "rule": "optional"
                      },
                      "squareTokenAssociation": {
                        "type": ".squareup.banking.Owner",
                        "id": 3,
                        "rule": "optional"
                      },
                      "bankingProduct": {
                        "type": ".squareup.bankingaccounts.external.model.BankAccount.AccountProductType",
                        "id": 4,
                        "rule": "optional"
                      },
                      "currency": {
                        "type": ".squareup.common.CurrencyCode",
                        "id": 7,
                        "rule": "optional"
                      },
                      "transferInEnabled": {
                        "type": "bool",
                        "id": 8,
                        "rule": "optional"
                      },
                      "transferOutEnabled": {
                        "type": "bool",
                        "id": 9,
                        "rule": "optional"
                      },
                      "bankcBalanceId": {
                        "type": "string",
                        "id": 17,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 5
                      },
                      "nicknameError": {
                        "type": ".squareup.bankingaccounts.external.model.Error",
                        "id": 6
                      },
                      "balancesInformation": {
                        "type": ".squareup.bankingaccounts.external.model.DepositAccount.BalanceInformation",
                        "id": 10
                      },
                      "balanceError": {
                        "type": ".squareup.bankingaccounts.external.model.Error",
                        "id": 11
                      },
                      "usSavingsData": {
                        "type": ".squareup.bankingaccounts.external.model.DepositAccount.UsSavingsData",
                        "id": 12
                      },
                      "usCheckingData": {
                        "type": ".squareup.bankingaccounts.external.model.DepositAccount.UsCheckingData",
                        "id": 13
                      },
                      "caFoldersData": {
                        "type": ".squareup.bankingaccounts.external.model.DepositAccount.CaFoldersData",
                        "id": 14
                      },
                      "caSquareCardData": {
                        "type": ".squareup.bankingaccounts.external.model.DepositAccount.CaSquareCardData",
                        "id": 15
                      },
                      "gbSquareCardData": {
                        "type": ".squareup.bankingaccounts.external.model.DepositAccount.GbSquareCardData",
                        "id": 16
                      }
                    },
                    "nested": {
                      "DepositAccountState": {
                        "values": {
                          "UNKNOWN_ACCOUNT_STATE_DO_NOT_USE": 0,
                          "ACCOUNT_STATE_OPEN": 1,
                          "ACCOUNT_STATE_PENDING_CLOSURE": 2,
                          "ACCOUNT_STATE_CLOSED": 3,
                          "ACCOUNT_STATE_PENDING_OPEN": 4
                        }
                      },
                      "BalanceInformation": {
                        "fields": {
                          "currentBalance": {
                            "type": ".squareup.connect.v2.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "availableBalance": {
                            "type": ".squareup.connect.v2.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "pendingBalance": {
                            "type": ".squareup.connect.v2.common.Money",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "UsCheckingData": {
                        "fields": {
                          "accountAndRoutingNumber": {
                            "type": ".squareup.bankingaccounts.external.model.DepositAccount.UsCheckingData.AccountSuffixAndRoutingNumber",
                            "id": 3
                          },
                          "accountSuffixError": {
                            "type": ".squareup.bankingaccounts.external.model.Error",
                            "id": 4
                          }
                        },
                        "nested": {
                          "AccountSuffixAndRoutingNumber": {
                            "fields": {
                              "accountNumberSuffix": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "routingNumber": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "account_suffix": {
                            "oneof": ["accountAndRoutingNumber", "accountSuffixError"]
                          }
                        }
                      },
                      "UsSavingsData": {
                        "fields": {
                          "parentAccountId": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "interestAccrualRateBps": {
                            "type": "int64",
                            "id": 2,
                            "rule": "optional"
                          },
                          "isLockedForFreeze": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional"
                          },
                          "category": {
                            "type": ".squareup.banking.Category",
                            "id": 6,
                            "rule": "optional"
                          },
                          "sfsAccountId": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "accountAndRoutingNumber": {
                            "type": ".squareup.bankingaccounts.external.model.DepositAccount.UsSavingsData.AccountSuffixAndRoutingNumber",
                            "id": 3
                          },
                          "accountSuffixError": {
                            "type": ".squareup.bankingaccounts.external.model.Error",
                            "id": 4
                          }
                        },
                        "nested": {
                          "AccountSuffixAndRoutingNumber": {
                            "fields": {
                              "accountNumberSuffix": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "routingNumber": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "account_suffix": {
                            "oneof": ["accountAndRoutingNumber", "accountSuffixError"]
                          }
                        }
                      },
                      "CaFoldersData": {
                        "fields": {
                          "category": {
                            "type": ".squareup.banking.Category",
                            "id": 1,
                            "rule": "optional"
                          }
                        }
                      },
                      "CaSquareCardData": {
                        "fields": {}
                      },
                      "GbSquareCardData": {
                        "fields": {}
                      },
                      "nickname": {
                        "oneof": ["name", "nicknameError"]
                      },
                      "balances": {
                        "oneof": ["balancesInformation", "balanceError"]
                      },
                      "product_specific_data": {
                        "oneof": ["usSavingsData", "usCheckingData", "caFoldersData", "caSquareCardData", "gbSquareCardData"]
                      }
                    }
                  },
                  "PaymentAccount": {
                    "fields": {
                      "id": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "unitToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "state": {
                        "type": ".squareup.bankingaccounts.external.model.PaymentAccount.PaymentAccountState",
                        "id": 3,
                        "rule": "optional"
                      },
                      "currency": {
                        "type": ".squareup.common.CurrencyCode",
                        "id": 6,
                        "rule": "optional"
                      },
                      "transferInEnabled": {
                        "type": "bool",
                        "id": 7,
                        "rule": "optional"
                      },
                      "transferOutEnabled": {
                        "type": "bool",
                        "id": 8,
                        "rule": "optional"
                      },
                      "pendingSettlementTime": {
                        "type": ".squareup.common.time.DateTime",
                        "id": 11,
                        "rule": "optional"
                      },
                      "bankcBalanceId": {
                        "type": "string",
                        "id": 12,
                        "rule": "optional"
                      },
                      "name": {
                        "type": "string",
                        "id": 4
                      },
                      "nicknameError": {
                        "type": ".squareup.bankingaccounts.external.model.Error",
                        "id": 5
                      },
                      "balancesInformation": {
                        "type": ".squareup.bankingaccounts.external.model.PaymentAccount.PaymentBalanceInformation",
                        "id": 9
                      },
                      "balanceError": {
                        "type": ".squareup.bankingaccounts.external.model.Error",
                        "id": 10
                      }
                    },
                    "nested": {
                      "PaymentAccountState": {
                        "values": {
                          "UNKNOWN_PAYMENT_ACCOUNT_STATE_DO_NOT_USE": 0,
                          "OPEN": 1,
                          "CLOSED": 2
                        }
                      },
                      "PaymentBalanceInformation": {
                        "fields": {
                          "currentBalance": {
                            "type": ".squareup.connect.v2.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "availableBalance": {
                            "type": ".squareup.connect.v2.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "pendingBalance": {
                            "type": ".squareup.connect.v2.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "defaultBalance": {
                            "type": ".squareup.ledger.BalanceTypeAmounts",
                            "id": 4,
                            "rule": "optional"
                          },
                          "feeBalance": {
                            "type": ".squareup.ledger.BalanceTypeAmounts",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "nickname": {
                        "oneof": ["name", "nicknameError"]
                      },
                      "balances": {
                        "oneof": ["balancesInformation", "balanceError"]
                      }
                    }
                  },
                  "CardDetails": {
                    "fields": {
                      "cardId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "isEligibleForPhysicalCardPair": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "Error": {
                    "fields": {
                      "code": {
                        "type": ".squareup.bankingaccounts.external.model.Error.Code",
                        "id": 1,
                        "rule": "optional"
                      },
                      "log": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "category": {
                        "type": ".squareup.bankingaccounts.external.model.Error.Category",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Code": {
                        "values": {
                          "UNKNOWN_ERROR_DO_NOT_USE": 0,
                          "MERCHANT_NOT_FOUND": 1,
                          "UNIT_NOT_FOUND": 2,
                          "UPSTREAM_SERVICE_DOWN": 3,
                          "NICKNAME_UNAVAILABLE": 4,
                          "ACCOUNT_NUMBER_SUFFIX_UNAVAILABLE": 5
                        }
                      },
                      "Category": {
                        "values": {
                          "UNKNOWN_CATEGORY_DO_NOT_USE": 0,
                          "API_ERROR": 1,
                          "INVALID_REQUEST_ERROR": 2
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.BankAccount && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.BankAccount?.nested?.AccountProductType && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.DepositAccount && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.DepositAccount?.nested?.DepositAccountState && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.DepositAccount?.nested?.BalanceInformation && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.DepositAccount?.nested?.UsCheckingData && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.DepositAccount?.nested?.UsCheckingData?.nested?.AccountSuffixAndRoutingNumber && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.DepositAccount?.nested?.UsSavingsData && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.DepositAccount?.nested?.UsSavingsData?.nested?.AccountSuffixAndRoutingNumber && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.DepositAccount?.nested?.CaFoldersData && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.DepositAccount?.nested?.CaSquareCardData && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.DepositAccount?.nested?.GbSquareCardData && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.PaymentAccount && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.PaymentAccount?.nested?.PaymentAccountState && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.PaymentAccount?.nested?.PaymentBalanceInformation && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.CardDetails && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.Error && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.Error?.nested?.Code && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.model?.nested?.Error?.nested?.Category) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BankAccount @ squareup/bankingaccounts/external/model/bank_account_model.proto at 16:1
 */
export const BankAccount = $root.lookupType('squareup.bankingaccounts.external.model.BankAccount');
fixType(BankAccount);
Builder.createAndAttachToType(BankAccount);
/**
 * SOURCE AccountProductType @ squareup/bankingaccounts/external/model/bank_account_model.proto at 25:3
 */
BankAccount.AccountProductType = $root.lookupEnum('squareup.bankingaccounts.external.model.BankAccount.AccountProductType').values;
/**
 * SOURCE DepositAccount @ squareup/bankingaccounts/external/model/bank_account_model.proto at 36:1
 */
export const DepositAccount = $root.lookupType('squareup.bankingaccounts.external.model.DepositAccount');
fixType(DepositAccount);
Builder.createAndAttachToType(DepositAccount);
/**
 * SOURCE DepositAccountState @ squareup/bankingaccounts/external/model/bank_account_model.proto at 84:3
 */
DepositAccount.DepositAccountState = $root.lookupEnum('squareup.bankingaccounts.external.model.DepositAccount.DepositAccountState').values;
/**
 * SOURCE BalanceInformation @ squareup/bankingaccounts/external/model/bank_account_model.proto at 92:3
 */
DepositAccount.BalanceInformation = $root.lookupType('squareup.bankingaccounts.external.model.DepositAccount.BalanceInformation');
fixType(DepositAccount.BalanceInformation);
Builder.createAndAttachToType(DepositAccount.BalanceInformation);
/**
 * SOURCE UsCheckingData @ squareup/bankingaccounts/external/model/bank_account_model.proto at 101:3
 */
DepositAccount.UsCheckingData = $root.lookupType('squareup.bankingaccounts.external.model.DepositAccount.UsCheckingData');
fixType(DepositAccount.UsCheckingData);
Builder.createAndAttachToType(DepositAccount.UsCheckingData);
/**
 * May be unavailable if upstream services are down.
 *
 * SOURCE AccountSuffixAndRoutingNumber @ squareup/bankingaccounts/external/model/bank_account_model.proto at 109:5
 */
DepositAccount.UsCheckingData.AccountSuffixAndRoutingNumber = $root.lookupType('squareup.bankingaccounts.external.model.DepositAccount.UsCheckingData.AccountSuffixAndRoutingNumber');
fixType(DepositAccount.UsCheckingData.AccountSuffixAndRoutingNumber);
Builder.createAndAttachToType(DepositAccount.UsCheckingData.AccountSuffixAndRoutingNumber);
/**
 * SOURCE UsSavingsData @ squareup/bankingaccounts/external/model/bank_account_model.proto at 118:3
 */
DepositAccount.UsSavingsData = $root.lookupType('squareup.bankingaccounts.external.model.DepositAccount.UsSavingsData');
fixType(DepositAccount.UsSavingsData);
Builder.createAndAttachToType(DepositAccount.UsSavingsData);
/**
 * May be unavailable if CorePro/Helix is down.
 *
 * SOURCE AccountSuffixAndRoutingNumber @ squareup/bankingaccounts/external/model/bank_account_model.proto at 141:5
 */
DepositAccount.UsSavingsData.AccountSuffixAndRoutingNumber = $root.lookupType('squareup.bankingaccounts.external.model.DepositAccount.UsSavingsData.AccountSuffixAndRoutingNumber');
fixType(DepositAccount.UsSavingsData.AccountSuffixAndRoutingNumber);
Builder.createAndAttachToType(DepositAccount.UsSavingsData.AccountSuffixAndRoutingNumber);
/**
 * SOURCE CaFoldersData @ squareup/bankingaccounts/external/model/bank_account_model.proto at 150:3
 */
DepositAccount.CaFoldersData = $root.lookupType('squareup.bankingaccounts.external.model.DepositAccount.CaFoldersData');
fixType(DepositAccount.CaFoldersData);
Builder.createAndAttachToType(DepositAccount.CaFoldersData);
/**
 * SOURCE CaSquareCardData @ squareup/bankingaccounts/external/model/bank_account_model.proto at 155:3
 */
DepositAccount.CaSquareCardData = $root.lookupType('squareup.bankingaccounts.external.model.DepositAccount.CaSquareCardData');
fixType(DepositAccount.CaSquareCardData);
Builder.createAndAttachToType(DepositAccount.CaSquareCardData);
/**
 * SOURCE GbSquareCardData @ squareup/bankingaccounts/external/model/bank_account_model.proto at 159:3
 */
DepositAccount.GbSquareCardData = $root.lookupType('squareup.bankingaccounts.external.model.DepositAccount.GbSquareCardData');
fixType(DepositAccount.GbSquareCardData);
Builder.createAndAttachToType(DepositAccount.GbSquareCardData);
/**
 * These accounts represent the ledger balance
 *
 * SOURCE PaymentAccount @ squareup/bankingaccounts/external/model/bank_account_model.proto at 165:1
 */
export const PaymentAccount = $root.lookupType('squareup.bankingaccounts.external.model.PaymentAccount');
fixType(PaymentAccount);
Builder.createAndAttachToType(PaymentAccount);
/**
 * SOURCE PaymentAccountState @ squareup/bankingaccounts/external/model/bank_account_model.proto at 205:3
 */
PaymentAccount.PaymentAccountState = $root.lookupEnum('squareup.bankingaccounts.external.model.PaymentAccount.PaymentAccountState').values;
/**
 * SOURCE PaymentBalanceInformation @ squareup/bankingaccounts/external/model/bank_account_model.proto at 211:3
 */
PaymentAccount.PaymentBalanceInformation = $root.lookupType('squareup.bankingaccounts.external.model.PaymentAccount.PaymentBalanceInformation');
fixType(PaymentAccount.PaymentBalanceInformation);
Builder.createAndAttachToType(PaymentAccount.PaymentBalanceInformation);
/**
 * During Checking/Square Card account creation, return additional information for Cards
 *
 * SOURCE CardDetails @ squareup/bankingaccounts/external/model/bank_account_model.proto at 228:1
 */
export const CardDetails = $root.lookupType('squareup.bankingaccounts.external.model.CardDetails');
fixType(CardDetails);
Builder.createAndAttachToType(CardDetails);
/**
 * SOURCE Error @ squareup/bankingaccounts/external/model/bank_account_model.proto at 238:1
 */
export const Error = $root.lookupType('squareup.bankingaccounts.external.model.Error');
fixType(Error);
Builder.createAndAttachToType(Error);
/**
 * SOURCE Code @ squareup/bankingaccounts/external/model/bank_account_model.proto at 243:3
 */
Error.Code = $root.lookupEnum('squareup.bankingaccounts.external.model.Error.Code').values;
/**
 * SOURCE Category @ squareup/bankingaccounts/external/model/bank_account_model.proto at 252:3
 */
Error.Category = $root.lookupEnum('squareup.bankingaccounts.external.model.Error.Category').values;